import {
  annotationsSelectors,
  applicationActions,
  applicationSelectors,
  textSelectionActions,
  textSelectionSelectors,
  useAppDispatch,
} from '@readcloud/state';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { TextSelectionContext } from '../../context/TextSelection';
import {
  ConnectedAnnotationAddModal,
  ConnectedAnnotationUpdateModal,
} from './ConnectedAnnotationModal';
import { ConnectedBookmarkForm } from './ConnectedBookmarkForm';
import {
  ImmersiveDialog,
  ImmersiveUserWorkbook,
} from './ImmersiveReader/ImmersiveReader';

interface IModalManagerProps {}

const ModalManager: React.FunctionComponent<IModalManagerProps> = (props) => {
  const appData = useSelector(applicationSelectors.getApplcationState);
  const selectionData = useSelector(textSelectionSelectors.getSelectionState);
  const selectedAnnotation = useSelector(
    annotationsSelectors.getSelectedAnnotation
  );

  const dispatch = useAppDispatch();

  const { selectionState, epubSection } =
    React.useContext(TextSelectionContext);

  return (
    <>
      {/* MODAL INSTANCES */}
      <ConnectedAnnotationUpdateModal
        open={appData.annotationUpdateModalOpen}
        previousAnnotation={selectedAnnotation}
        noColor={!selectedAnnotation?.location}
        noteRequired={selectedAnnotation?.bookType === 'MEDIA'}
        selectionState={selectionState}
        onCancel={() =>
          dispatch(
            applicationActions.updateApplication({
              annotationUpdateModalOpen: false,
            })
          )
        }
        onSuccess={() => {
          //dispatch(annotationsActions.setSelectedAnnotation(undefined));
          dispatch(
            applicationActions.updateApplication({
              annotationUpdateModalOpen: false,
            })
          );
        }}
      />

      <ConnectedAnnotationAddModal
        open={appData.annotationAddModalOpen}
        selectionState={selectionState}
        section={epubSection}
        onCancel={() =>
          dispatch(
            applicationActions.updateApplication({
              annotationAddModalOpen: false,
            })
          )
        }
        onSuccess={() => {
          dispatch(
            applicationActions.updateApplication({
              annotationAddModalOpen: false,
            })
          );
        }}
      />

      <ConnectedBookmarkForm
        open={appData.bookmarkModalOpen}
        selectionState={selectionState}
        onCancel={() =>
          dispatch(
            applicationActions.updateApplication({ bookmarkModalOpen: false })
          )
        }
        onSuccess={() => {
          document.getSelection().removeAllRanges();
          dispatch(
            applicationActions.updateApplication({ bookmarkModalOpen: false })
          );
        }}
      />
      <ImmersiveUserWorkbook
        open={appData.immersiveWorkbookModalOpen}
        currentText={selectionState?.selectedText}
        handleImmersiveInput={(text: string) => {
          dispatch(
            textSelectionActions.updateSelectionData({
              selectedText: text.replace(/[^\S ]+/g, ' '),
            })
          );
        }}
        handleOpenImmersive={() => {
          dispatch(
            applicationActions.updateApplication({
              immersiveReaderModalOpen: true,
            })
          );
        }}
        onCancel={() =>
          dispatch(
            applicationActions.updateApplication({
              immersiveWorkbookModalOpen: false,
            })
          )
        }
        isOnline={true}
        checkOnline={() => true}
      />

      <ImmersiveDialog
        open={appData.immersiveReaderModalOpen}
        selectedText={selectionData?.selectedText}
        getImmersiveToken={() =>
          dispatch(applicationActions.asyncActions.getImmersiveToken())
        }
        onCancel={() => {
          dispatch(
            applicationActions.updateApplication({
              immersiveReaderModalOpen: false,
            })
          );
          dispatch(textSelectionActions.resetSelectionData());
        }}
        toggleIOSInterceptor={(status) =>
          dispatch(
            applicationActions.asyncActions.updateNativeInterceptor(status)
          )
        }
      />
    </>
  );
};

export default ModalManager;
